import { render, staticRenderFns } from "./PortalFileInput.vue?vue&type=template&id=124ef9a2&scoped=true&"
import script from "./PortalFileInput.vue?vue&type=script&lang=js&"
export * from "./PortalFileInput.vue?vue&type=script&lang=js&"
import style0 from "./PortalFileInput.vue?vue&type=style&index=0&id=124ef9a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ef9a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124ef9a2')) {
      api.createRecord('124ef9a2', component.options)
    } else {
      api.reload('124ef9a2', component.options)
    }
    module.hot.accept("./PortalFileInput.vue?vue&type=template&id=124ef9a2&scoped=true&", function () {
      api.rerender('124ef9a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PortalFileInput.vue"
export default component.exports